<script>
import './stylesheets/components/VsLayout';

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.toLowerCase().slice(1);
};

export default {
  name: 'VsLayout',
  props: [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl',

    'offsetXs',
    'offsetSm',
    'offsetMd',
    'offsetLg',
    'offsetXl',
    'offsetXxl',

    'noFlex',
    'noGutter',
    'noGutterLeftXs',
    'noGutterLeftSm',
    'noGutterLeftMd',
    'noGutterLeftLg',
    'noGutterLeftXl',
    'noGutterLeftXxl',
    'noGutterRightXs',
    'noGutterRightSm',
    'noGutterRightMd',
    'noGutterRightLg',
    'noGutterRightXl',
    'noGutterRightXxl',

    'horzAlignLeftXs',
    'horzAlignLeftSm',
    'horzAlignLeftMd',
    'horzAlignLeftLg',
    'horzAlignLeftXl',
    'horzAlignLeftXxl',

    'horzAlignCenterXs',
    'horzAlignCenterSm',
    'horzAlignCenterMd',
    'horzAlignCenterLg',
    'horzAlignCenterXl',
    'horzAlignCenterXxl',

    'horzAlignRightXs',
    'horzAlignRightSm',
    'horzAlignRightMd',
    'horzAlignRightLg',
    'horzAlignRightXl',
    'horzAlignRightXxl',

    'vertAlignStretchXs',
    'vertAlignStretchSm',
    'vertAlignStretchMd',
    'vertAlignStretchLg',
    'vertAlignStretchXl',
    'vertAlignStretchXxl',

    'vertAlignTopXs',
    'vertAlignTopSm',
    'vertAlignTopMd',
    'vertAlignTopLg',
    'vertAlignTopXl',
    'vertAlignTopXxl',

    'vertAlignCenterXs',
    'vertAlignCenterSm',
    'vertAlignCenterMd',
    'vertAlignCenterLg',
    'vertAlignCenterXl',
    'vertAlignCenterXxl',

    'vertAlignBottomXs',
    'vertAlignBottomSm',
    'vertAlignBottomMd',
    'vertAlignBottomLg',
    'vertAlignBottomXl',
    'vertAlignBottomXxl',

    'autoXs',
    'autoSm',
    'autoMd',
    'autoLg',
    'autoXl',
    'autoXxl',

    'wrapXs',
    'wrapSm',
    'wrapMd',
    'wrapLg',
    'wrapXl',
    'wrapXxl',

    'noWrapXs',
    'noWrapSm',
    'noWrapMd',
    'noWrapLg',
    'noWrapXl',
    'noWrapXxl',

    'growXs',
    'growSm',
    'growMd',
    'growLg',
    'growXl',
    'growXxl',

    'noShrinkXs',
    'noShrinkSm',
    'noShrinkMd',
    'noShrinkLg',
    'noShrinkXl',
    'noShrinkXxl',

    'colXs',
    'colSm',
    'colMd',
    'colLg',
    'colXl',
    'colXxl',

    'rowXs',
    'rowSm',
    'rowMd',
    'rowLg',
    'rowXl',
    'rowXxl',

    'spaceAroundXs',
    'spaceAroundSm',
    'spaceAroundMd',
    'spaceAroundLg',
    'spaceAroundXl',
    'spaceAroundXxl',

    'spaceBetweenXs',
    'spaceBetweenSm',
    'spaceBetweenMd',
    'spaceBetweenLg',
    'spaceBetweenXl',
    'spaceBetweenXxl',

    'hideXsDown',
    'hideSmDown',
    'hideMdDown',
    'hideLgDown',
    'hideXlDown',

    'hideSmUp',
    'hideMdUp',
    'hideLgUp',
    'hideXlUp',
    'hideXxlUp',

    'marginBottom',
    'marginTop',

    'inline',
  ],
  data() {
    return {
      sizes: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
    };
  },
  computed: {
    classes() {
      let classes = {
        ...this.generateClasses('vs-layout--h-align-left', 'horzAlignLeft'),
        ...this.generateClasses('vs-layout--h-align-center', 'horzAlignCenter'),
        ...this.generateClasses('vs-layout--h-align-right', 'horzAlignRight'),
        ...this.generateClasses('vs-layout--v-align-stretch', 'vertAlignStretch'),
        ...this.generateClasses('vs-layout--v-align-top', 'vertAlignTop'),
        ...this.generateClasses('vs-layout--v-align-center', 'vertAlignCenter'),
        ...this.generateClasses('vs-layout--v-align-bottom', 'vertAlignBottom'),
        ...this.generateClasses('vs-layout--auto', 'auto'),
        ...this.generateClasses('vs-layout--wrap', 'wrap'),
        ...this.generateClasses('vs-layout--no-wrap', 'noWrap'),
        ...this.generateClasses('vs-layout--grow', 'grow'),
        ...this.generateClasses('vs-layout--no-shrink', 'noShrink'),
        ...this.generateClasses('vs-layout--col', 'col'),
        ...this.generateClasses('vs-layout--row', 'row'),
        ...this.generateClasses('vs-layout--space-around', 'spaceAround'),
        ...this.generateClasses('vs-layout--space-between', 'spaceBetween'),
        ...this.generateClasses('vs-layout--no-gutter-left', 'noGutterLeft'),
        ...this.generateClasses('vs-layout--no-gutter-right', 'noGutterRight'),
        ...this.generateHideClasses('down'),
        ...this.generateHideClasses('up'),
        ...this.generateColClasses(),
        ...this.generateOffsetClasses(),
        'vs-layout--no-flex': this.noFlex,
        'vs-layout--no-gutter': this.noGutter,
        'vs-layout--margin-bottom-1': this.marginBottom == 1,
        'vs-layout--margin-bottom-2': this.marginBottom == 2,
        'vs-layout--margin-bottom-3': this.marginBottom == 3,
        'vs-layout--margin-top-1': this.marginTop == 1,
        'vs-layout--margin-top-2': this.marginTop == 2,
        'vs-layout--margin-top-3': this.marginTop == 3,
        'vs-layout--inline': this.inline,
      };

      return classes;
    }
  },
  methods: {
    generateClasses(cssClass, baseProperty) {
      let classes = {};
      for (let i = 0; i < this.sizes.length; i++) {
        let size = this.sizes[i];
        classes[`${cssClass}-${size}`] = this[`${baseProperty}${size.capitalize()}`];
      }
      return classes;
    },
    generateHideClasses(direction) {
      let classes = {};
      for (let i = 0; i < this.sizes.length; i++) {
        let size = this.sizes[i];
        classes[`vs-layout--hide-${size}-${direction}`] = this[`hide${size.capitalize()}${direction.capitalize()}`];
      }
      return classes;
    },
    generateColClasses() {
      let classes = {};
      for (let i = 0; i < this.sizes.length; i++) {
        let size = this.sizes[i];
        if (this[size]) classes[`vs-layout--${size}-${this[size]}`] = true;
      }
      return classes;
    },
    generateOffsetClasses() {
      let classes = {};
      for (let i = 0; i < this.sizes.length; i++) {
        let size = this.sizes[i];
        if (this[`offset${size.capitalize()}`]) classes[`vs-layout--offset-${size}-${this[`offset${size.capitalize()}`]}`] = true;
      }
      return classes;
    },
  },
};
</script>

<template lang='pug'>
.vs-layout(:class='classes')
  slot
</template>